var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgmMap, AgmMarker } from '@agm/core';
import { AgmSnazzyInfoWindow } from '@agm/snazzy-info-window';
import { OnInit, QueryList } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VisitorCalendarActionCommand } from '../../../commands/pagination.query.command';
import { BaseComponent } from '../../../common/components/base.component';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { isNullOrUndefined, clone } from '../../../common/extensions';
import { GoogleMapsService } from '../../../common/services/google.maps.service';
import { HubEvent } from '../../../models/hub/hub.event';
import { ConfigService } from '../../../services/config.service';
import { EventTimeService } from '../../../services/event.time.service';
import { GeoService } from '../../../services/geo.service';
import { ImageService } from '../../../services/image.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { AllFrontendSettingsStore, VisitorCalendarStore } from '../../../stores/visitor.calendar.store';
import { config } from '../../../../config/config';
import { EventDetailsModalActions } from "../event.details.modal/event.details.modal.provider";
import { EventDetailsModalComponent } from "../event.details.modal/event.details.modal.component";
import { TripDetailModalActions, TripDetailModalData } from "../trip/trip.detail.modal/trip.detail.modal.provider";
import { TripDetailModalComponent } from "../trip/trip.detail.modal/trip.detail.modal.component";
import { ModalService } from "../../../common/services/modal.service";
var VisitorEventMapComponent = /** @class */ (function (_super) {
    __extends(VisitorEventMapComponent, _super);
    function VisitorEventMapComponent(router, visitorApiService, googleMapService, imageService, modalService, visitorCalendarStore, allFrontendSettingsStore, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.visitorApiService = visitorApiService;
        _this.googleMapService = googleMapService;
        _this.imageService = imageService;
        _this.modalService = modalService;
        _this.visitorCalendarStore = visitorCalendarStore;
        _this.allFrontendSettingsStore = allFrontendSettingsStore;
        _this.activatedRoute = activatedRoute;
        _this.lat = ConfigService.config.google.USCenter.lat;
        _this.lng = ConfigService.config.google.USCenter.lng;
        _this.isLoading = false;
        _this.paginationIndex = 0;
        _this.paginationPageLimit = 20;
        _this.noMoreNext = false;
        _this.noMoreBack = true;
        _this.actionCommand = new VisitorCalendarActionCommand();
        _this.showGroupInfowWindow = false;
        _this.canMarkerMouseOver = true;
        _this.groupLat = 0;
        _this.groupLng = 0;
        _this.iconUrl = ConfigService.config.google.iconUrl;
        _this.hideIconMapStyler = ConfigService.config.google.hideMapBusinessIconStyles;
        _this.isSideBarOpened = false;
        _this.isNeedSideEventList = false;
        _this.isMapFullSize = false;
        _this.customEvents = [];
        return _this;
    }
    VisitorEventMapComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.actionCommand.isMapView = true;
        // this.visitorCalendarStore.actionCommand.next(this.actionCommand);
        // this.getEvents();
        this.allFrontendSettingsStore.allFrontendSettingsCommand.takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            if (command.customSettings) {
                _this.customEvents = command.customSettings.customEvents || null;
            }
        });
        this.visitorCalendarStore.actionCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (command) {
            console.log('command got in map', command);
            _this.actionCommand = clone(command);
            _this.getEvents();
        });
    };
    VisitorEventMapComponent.prototype.getEvents = function () {
        var _this = this;
        this.isLoading = true;
        this.isInfoWindowsOpen = [];
        var limit = config.searchLimit; // 0 represents no limit, but seems only 9 records can be found if this set to 0
        this.actionCommand.queryCommand.limit = limit;
        this.visitorApiService.getEvents(this.hubName, this.actionCommand.queryCommand
        // {limit: limit, page: 1, category: this.actionCommand.queryCommand.category}
        )
            .subscribe(function (data) {
            data = data.filter(function (x) { return x.address && !x.isOnlineEvent; });
            EventTimeService.formatEventTime(data);
            _this.allEvents = data;
            if (data.length > _this.paginationPageLimit) {
                var max = _this.paginationPageLimit * (_this.paginationIndex + 1);
                max = max < _this.allEvents.length ? max : _this.allEvents.length;
                _this.events = data.slice(0, max);
                _this.showingCount = _this.paginationPageLimit * _this.paginationIndex + 1 + " - " + max;
            }
            else {
                _this.events = data;
                _this.showingCount = null;
            }
            _this.events.forEach(function (x) {
                _this.isInfoWindowsOpen.push(false);
            });
            _this.fitBounds();
            _this.isLoading = false;
        });
    };
    VisitorEventMapComponent.prototype.showInfoWindowOnMarker = function (index) {
        var _this = this;
        if (!this.canMarkerMouseOver) {
            return;
        }
        var overlapGroup = [];
        this.markerOverlappings.forEach(function (x) {
            if (x.any(function (y) { return y === index; })) {
                overlapGroup = x;
            }
        });
        if (overlapGroup.length) {
            console.log(overlapGroup.map(function (x) {
                return x;
            }));
            this.groupEvents = [];
            var lat_1 = 0;
            var lng_1 = 0;
            overlapGroup.forEach(function (x) {
                _this.groupEvents.push(_this.events[x]);
                var marker = _this.mapMarkers.find(function (m, i) {
                    return i === x;
                });
                lat_1 += marker.latitude;
                lng_1 += marker.longitude;
            });
            this.groupLat = lat_1 / overlapGroup.length;
            this.groupLng = lng_1 / overlapGroup.length;
            this.hideAllSingleInfoWindow();
            this.showGroupInfowWindow = true;
        }
        else {
            this.showInfoWindowByIndex(index);
        }
    };
    VisitorEventMapComponent.prototype.showInfoWindowByIndex = function (index) {
        var _this = this;
        this.hideAllSingleInfoWindow();
        this.currentIndex = index;
        setTimeout(function () {
            _this.isInfoWindowsOpen[index] = true;
            _this.showGroupInfowWindow = false;
        });
    };
    VisitorEventMapComponent.prototype.groupInfoWindowCloses = function () {
        this.showGroupInfowWindow = false;
    };
    VisitorEventMapComponent.prototype.mapZoomChange = function () {
        this.organizeMarkersForOverlapping();
        this.hideAllInfoWindow();
    };
    VisitorEventMapComponent.prototype.removeDisplayInfoWindow = function () {
        this.canMarkerMouseOver = false;
        // this.mapMarkers.forEach(marker => {
        //     marker.mouseOver.complete();
        // });
    };
    VisitorEventMapComponent.prototype.addDisplayInfoWindow = function () {
        var _this = this;
        setTimeout(function () {
            _this.canMarkerMouseOver = true;
        }, 200);
    };
    VisitorEventMapComponent.prototype.pagingBack = function () {
        if (this.noMoreBack) {
            return;
        }
        this.paginationIndex--;
        var start = this.paginationPageLimit * this.paginationIndex;
        var end = start + this.paginationPageLimit;
        if (start <= 0) {
            start = 0;
            this.noMoreBack = true;
        }
        this.events = this.allEvents.slice(start, end);
        this.showingCount = start + 1 + " - " + end;
        this.noMoreNext = false;
        this.fitBounds();
    };
    VisitorEventMapComponent.prototype.pagingNext = function () {
        if (this.noMoreNext) {
            return;
        }
        this.paginationIndex++;
        var start = this.paginationPageLimit * this.paginationIndex;
        var end = start + this.paginationPageLimit;
        if (end >= this.allEvents.length) {
            end = this.allEvents.length;
            this.noMoreNext = true;
        }
        this.events = this.allEvents.slice(start, end);
        this.showingCount = start + 1 + " - " + end;
        this.noMoreBack = false;
        this.fitBounds();
    };
    VisitorEventMapComponent.prototype.back = function () {
        var _this = this;
        this.actionCommand.isMapView = false;
        this.router.navigateByUrl(getRouteUrl(routeConfigs.visitor.eventCalendar, {
            hubName: this.hubName
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
        setTimeout(function () {
            _this.visitorCalendarStore.actionCommand.next(_this.actionCommand);
        });
    };
    VisitorEventMapComponent.prototype.resizeMap = function () {
        this.isMapFullSize = !this.isMapFullSize;
    };
    VisitorEventMapComponent.prototype.organizeMarkersForOverlapping = function () {
        var _this = this;
        this.markerOverlappings = [];
        this.mapMarkers.forEach(function (x, indexX) {
            _this.mapMarkers.forEach(function (y, indexY) {
                if (x !== y) {
                    if (_this.isMarkersOverlapping(x, y)) {
                        var toInsert_1 = true;
                        _this.markerOverlappings.forEach(function (m) {
                            if (m.any(function (o) { return o === indexX || o === indexY; })) {
                                if (!m.any(function (o) { return o === indexX; })) {
                                    m.push(indexX);
                                }
                                if (!m.any(function (o) { return o === indexY; })) {
                                    m.push(indexY);
                                }
                                toInsert_1 = false;
                            }
                        });
                        if (toInsert_1) {
                            _this.markerOverlappings.push([indexX, indexY]);
                        }
                    }
                }
            });
        });
    };
    VisitorEventMapComponent.prototype.isMarkersOverlapping = function (marker1, marker2) {
        var zoom = this.map.zoom;
        var dis = GeoService.getDistanceFromLatLng(marker1.latitude, marker1.longitude, marker2.latitude, marker2.longitude);
        var metersPerPx = 156543.03392 * Math.cos(marker1.latitude * Math.PI / 180) / Math.pow(2, zoom);
        var pxDistance = dis / metersPerPx;
        return pxDistance <= 10;
    };
    VisitorEventMapComponent.prototype.hideAllSingleInfoWindow = function () {
        for (var i = 0; i < this.isInfoWindowsOpen.length; i++) {
            this.isInfoWindowsOpen[i] = false;
        }
    };
    VisitorEventMapComponent.prototype.hideAllInfoWindow = function () {
        this.hideAllSingleInfoWindow();
        this.showGroupInfowWindow = false;
    };
    VisitorEventMapComponent.prototype.hideInfoWindow = function (marker) {
        // this.timeout = setTimeout(function () {
        //     // marker._closeInfoWindow();
        // }, 1500);
    };
    VisitorEventMapComponent.prototype.showDetails = function (id) {
        var event = this.events.find(function (x) { return x._id === id; });
        if (!this.isMobile) {
            event.hubName = this.hubName;
            var actions = {
                confirm: function (event, data) {
                }
            };
            this.modalService.show({
                component: EventDetailsModalComponent,
                providers: [
                    { provide: EventDetailsModalActions, useValue: actions },
                    { provide: HubEvent, useValue: event },
                ],
                panelClass: 'modal-fixed-top-lower'
            });
        }
        else {
            this.showDetailModalForMobile(event, 'event');
        }
    };
    VisitorEventMapComponent.prototype.showDetailModalForMobile = function (item, displayingOn, isShowAddToTripBtn, index) {
        if (isShowAddToTripBtn === void 0) { isShowAddToTripBtn = false; }
        var actions = {
            confirm: function (event) {
            }
        };
        this.modalService.show({
            component: TripDetailModalComponent,
            providers: [
                { provide: TripDetailModalActions, useValue: actions },
                {
                    provide: TripDetailModalData,
                    useValue: new TripDetailModalData(item, displayingOn, this.hubName, null, null, isShowAddToTripBtn, index)
                }
            ],
            panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
        });
    };
    VisitorEventMapComponent.prototype.fitBounds = function () {
        var _this = this;
        this.googleMapService.getGoogle().then(function () {
            _this.latLngBounds = new google.maps.LatLngBounds();
            _this.events.forEach(function (x) {
                if (!isNullOrUndefined(x.address.lat) && !isNullOrUndefined(x.address.lng)) {
                    _this.latLngBounds.extend(new google.maps.LatLng(x.address.lat, x.address.lng));
                }
            });
        });
    };
    VisitorEventMapComponent.prototype.openedChange = function () {
        return !this.isNeedSideEventList;
    };
    return VisitorEventMapComponent;
}(BaseComponent));
export { VisitorEventMapComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/event.map/visitor.event.map.component.ts.pre-build-optimizer.js